import { render, staticRenderFns } from "./UserCreationStep3Print.vue?vue&type=template&id=54bf109a"
import script from "./UserCreationStep3Print.vue?vue&type=script&lang=ts"
export * from "./UserCreationStep3Print.vue?vue&type=script&lang=ts"
import style0 from "./UserCreationStep3Print.vue?vue&type=style&index=0&id=54bf109a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports